export var AuthorizeActionType;
(function (AuthorizeActionType) {
    AuthorizeActionType["LOGIN"] = "LOGIN";
    AuthorizeActionType["LOGOUT"] = "LOGOUT";
    AuthorizeActionType["SIGNUP"] = "SIGNUP";
    AuthorizeActionType["UPDATE_PASSWORD"] = "UPDATE_PASSWORD";
})(AuthorizeActionType || (AuthorizeActionType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/authorizeActionType.ts
// module id = 289
// module chunks = 50